import { render, staticRenderFns } from "./LActionCard.vue?vue&type=template&id=4035bae7&scoped=true"
import script from "./LActionCard.vue?vue&type=script&lang=js"
export * from "./LActionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035bae7",
  null
  
)

export default component.exports